import React from "react";
import { Input } from "components/Input";
import { Col, Row } from "styles";
import Steps from "./Steps";

export function Premix(props) {
  const inputHandler = (e) => {
    const copyMegg = { ...props.megg };
    copyMegg.premixProductionYear = e.target.value;
    copyMegg.premixSteps.pre.feedProductionYear = (
      e.target.value * 0.053
    ).toFixed(2);
    copyMegg.premixSteps.initial.feedProductionYear = (
      e.target.value * 0.211
    ).toFixed(2);
    copyMegg.premixSteps.growth.feedProductionYear = (
      e.target.value * 0.568
    ).toFixed(2);
    copyMegg.premixSteps.final.feedProductionYear = (
      e.target.value * 0.168
    ).toFixed(2);
    props.setMegg(copyMegg);
  };

  return (
    <>
      <Row>
        <Col size={1}>
          <Input
            type="input"
            label="Produção Ração/Ano"
            inputType="number"
            value={props.megg.premixProductionYear}
            onChange={inputHandler}
          />
        </Col>
        <Col size={2}>
          <Input
            type="select"
            params="premixComposition"
            item={props.megg}
            setItem={props.setMegg}
            label="Composição do Premix"
            placeholder="Selecione o Composição"
            options={props.config
              .filter((item) => item.key === "premixComposition")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="premixPlaxma"
            item={props.megg}
            setItem={props.setMegg}
            label="Utiliza Plasma"
          />
        </Col>
        <Col>
          <Input
            type="checkbox"
            params="premixHemoglobin"
            item={props.megg}
            setItem={props.setMegg}
            label="Utiliza Hemoglobina"
          />
        </Col>
        <Col>
          <Input
            type="checkbox"
            params="premixAnimalFeed"
            item={props.megg}
            setItem={props.setMegg}
            label="Usa Ração Animal"
          />
        </Col>
        <Col>
          <Input
            type="select"
            params="premixAnimalFeedType"
            item={props.megg}
            setItem={props.setMegg}
            placeholder="Selecione um opção"
            options={props.config
              .filter((item) => item.key === "premixAnimalFeedType")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
      </Row>
      <div
        className="kt-separator kt-separator--solid"
        style={{ marginTop: 0 }}
      />
      <Steps {...props} />
    </>
  );
}
